import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./LeaveDetails.css";

export default function LeaveStatus() {
  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const employeeId = localUser?.id;
  const [leaveDetails, setLeaveDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formatDate = (value) => {
    if (!value) {
      return "";
    }

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
      return "";
    }

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const getDurationLabel = (hfDay) => {
    if (hfDay === "F") {
      return "First Half";
    }

    if (hfDay === "S") {
      return "Second Half";
    }

    return "Full Day";
  };

  const fetchStatus = useCallback(async () => {
    if (!employeeId) {
      setError("Unauthorized access Or Session Timed out.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await axios.get("/api/employees/leave-details", {
        params: { EmployeeID: employeeId }
      });

      setLeaveDetails(Array.isArray(response?.data?.data) ? response.data.data : []);
    } catch (e) {
      setError("Failed to fetch leave status.");
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return (
    <div className="leave-details-wrap">
      <div className="leave-top-links">
        <Link to="/new-emp-leave" className="btn btn-primary btn-sm">Apply Leave</Link>
        <Link to="/LeaveDetails" className="btn btn-primary btn-sm">Leave Details</Link>
      </div>

      <h3 className="leave-page-title">Leave Record</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="leave-results-wrap">
        <table border="1">
          <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
            <tr>
              <th>SNo</th>
              <th>LeaveType</th>
              <th>FromDate</th>
              <th>ToDate</th>
              <th>Days</th>
              <th>Duration</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>LeaveID</th>
              <th>Print</th>
              <th>Attachment</th>
              <th>Progress</th>
            </tr>
          </thead>
          <tbody>
            {leaveDetails.map((leave, index) => (
              <tr key={leave.LeaveID}>
                <td>{index + 1}</td>
                <td>{leave.LeaveType}</td>
                <td>{formatDate(leave.FromDate)}</td>
                <td>{formatDate(leave.ToDate)}</td>
                <td>{leave.NoOfDays}</td>
                <td>{getDurationLabel(leave.HFDay)}</td>
                <td>{leave.Remarks}</td>
                <td>{leave.Status}</td>
                <td>{leave.LeaveID}</td>
                <td><button type="button">Print</button></td>
                <td>
                  <button
                    type="button"
                    onClick={() => {
                      if (leave.SupportingDoc) {
                        window.open(leave.SupportingDoc, "_blank", "noopener,noreferrer");
                      }
                    }}
                  >
                    Attachment
                  </button>
                </td>
                <td><button type="button">Progress</button></td>
              </tr>
            ))}
            {!loading && leaveDetails.length === 0 && (
              <tr>
                <td colSpan="12" className="leave-empty-row">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
